module.exports = __webpack_public_path__ + "static/img/091_TO8_1757_og.467f508.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/091_TO8_1757_og.jpg
// module id = R/nO
// module chunks = 0